import Home from "./views/Home/Home.tsx";
import MyDocuments from "./views/MyDocuments/MyDocuments.tsx";
import CreateDocument from "./views/CreateDocument/CreateDocument.tsx";
import Login from "./views/Login/Login.tsx";
import OfficeProfile from "./views/Profile.tsx";
import Register from "./views/Register.tsx";
import SignDocument from "./views/SignDocument/SignDocument.tsx";
import ForgotPassword from "./views/ForgotPassword/ForgotPassword.tsx";
import ResetPassword from "./views/ResetPassword/ResetPassword.tsx";
import ActiveUser from "./views/ActiveUser/ActiveUser.tsx";
import ActiveUserInfo from "./views/ActiveUserInfo/ActiveUserInfo.tsx";
import Settings from "./views/Settings/Settings.tsx";
import Contacts from "./views/Contacts/Contacts.tsx";
import Templates from "./views/Templates/Templates.tsx";
import AddSignatories from "./views/AddSignatories/AddSignatories.tsx";

export const routesOffice = [
  {
    path: "/index",
    name: "Home",
    icon: "fa-solid fa-building",
    component: <Home />,
    layout: "/admin",
  },
  {
    path: "/my-documents",
    name: "Documentos",
    icon: "fa fa-file-alt",
    component: <MyDocuments />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Perfil",
    icon: "fa-regular fa-address-card",
    component: <OfficeProfile />,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: "Configurações",
    icon: "fa-solid fa-gear",
    component: <Settings />,
    layout: "/admin",
  },
  {
    path: "/contacts",
    name: "Contatos",
    icon: "fa-solid fa-address-book",
    component: <Contacts />,
    layout: "/admin",
  },
  {
    path: "/template",
    name: "Templates",
    icon: "fa-solid fa-file-contract",
    component: <Templates />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/create-documents",
    name: "noShow",
    component: <CreateDocument />,
    layout: "/admin",
  },
  {
    path: "/add-signatories",
    name: "noShow",
    component: <AddSignatories />,
    layout: "/admin",
  },
  {
    path: "/forgot-password",
    name: "noShow",
    component: <ForgotPassword />,
    layout: "/auth",
  },
  {
    path: "/resetpassword",
    name: "noShow",
    component: <ResetPassword />,
    layout: "/auth",
  },
  {
    path: "/activeuser",
    name: "noShow",
    component: <ActiveUser />,
    layout: "/auth",
  },
  {
    path: "/activeuserinfo",
    name: "noShow",
    component: <ActiveUserInfo />,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "noShow",
    component: <Register />,
    layout: "/auth",
  },
  {
    path: "/sign-document",
    name: "noShow",
    component: <SignDocument />,
    layout: "/admin",
  },
];
